<template>
	<div></div>
</template>
<script>
import {
	USER_INFO
} from '../store/mutation-types'
import { checksessionkey } from "../scripts/auth";
export default {
  name: "ShowInWebview",
  async mounted() {  
   const token = this.$route.query.ssstoken;
   if (!(token === null || token === undefined || token === "")) {
	   let userinfo= await  checksessionkey(token);
	   if(userinfo!=null)
	   {
		  this.$store.dispatch(USER_INFO,userinfo);
	   }
   }
   const url= this.$route.query.url;
   if(url)
   {
	  window.location.href = url;
   }
  }
 
};

</script>

<style>
</style>